<template>
  <div class="dashboard-status">
    <MessageBarV02
      v-if="type === 'alert'"
      v-model="localShow"
      color="#f6bc50"
      dense
      dismissible
      transition="fade-transition"
      tile
    >
      {{message}}
    </MessageBarV02>
    <MessageBarV02
      v-if="show && type === 'general'"
      color="#223448"
      dark
      dense
      transition="fade-transition"
      tile
    >
      {{message}}
    </MessageBarV02>
  </div>
</template>
<script>
import { MessageBarV02 } from '@mikmak/components';

export default {
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'alert',
    },
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localShow: this.show,
    };
  },
  components: {
    MessageBarV02,
  },
  watch: {
    localShow(val) {
      if (val === false) this.$emit('dismiss');
    },
    show() {
      this.localShow = this.show;
    },
  },
};
</script>

<style scoped>
.dashboard-status {
  margin: auto;
}
</style>
